export class UserSettings {
  public ladderId: string;
  public ladderName: string;
  public levelId: number;
  public levelName: number;

  constructor(data?: Partial<UserSettings>) {
    Object.assign(this, data);
  }
}

export class OpponentPlayer {
  public id: string;
  public name: string;
  constructor(data?: Partial<OpponentPlayer>) {
    Object.assign(this, data);
  }
}

export class Player {
  public id: string;
  public firstName: string;
  public lastName: string;
  public phoneNumber: string;
  public email: string;
  public paid: boolean;
  public ladderId: string;
  public ladderName: string;
  public ladderType: string;
  public levelId: number;
  public levelName: number;
  public isDoubles: boolean;
  public doublesId: string;
  public doublesName: string;
  // doesn't come down by default from server, but we can fetch it if we want
  public avatar: string = null;
  public matchCount: number;
  public rank: string;

  public getFullName = () => `${this.firstName} ${this.lastName}`;
  public getShortName = () => `${this.firstName} ${this.lastName.charAt(0)}`;
  constructor(data?: Partial<Player>) {
    Object.assign(this, data);
  }
}



